import React, {createContext, ReactNode, useContext} from 'react';
import {fetchConfigPosts} from '../api/wordpress';
import {SiteConfig} from '../types';
import {toSiteConfig} from './siteConfig';
import {useCachedResource} from './useCachedResource';

const ConfigContext = createContext<SiteConfig | undefined>(undefined);

const loadSiteConfig = async () => toSiteConfig(await fetchConfigPosts());

/** Loads the JSON config posts from WordPress once and shares them with the whole app. */
export const ConfigProvider = ({children}: { children: ReactNode }) => {
    const {data} = useCachedResource('config', loadSiteConfig);
    return <ConfigContext.Provider value={data}>{children}</ConfigContext.Provider>;
};

/** The site config, or `undefined` while it is still loading. */
export const useSiteConfig = () => useContext(ConfigContext);
